import React from 'react';
import './SchedulePage.css';

function SchedulePage() {
  const scheduleByDay = [
    {
      day: 'Monday, June 1, 2026',
      morning: [
        { title: 'Asia-Pacific Committee (APC)', location: 'ADAGP Auditorium', time: '09:30-12:30' },
        { title: 'African Committee (CAF)', location: 'CISAC', time: 'Time TBC' }
      ],
      afternoon: [
        { title: 'Asia-Pacific Committee (APC)', location: 'ADAGP Auditorium', time: '14:00-17:30' },
        { title: 'African Committee (CAF)', location: 'CISAC', time: 'Time TBC' }
      ]
    },
    {
      day: 'Tuesday, June 2, 2026',
      morning: [
        { title: 'Asia-Pacific and Latin American & Caribbean Committees (APC/CLC)', location: 'ADAGP Auditorium', time: '10:00-12:00' },
        { title: 'African Committee (CAF)', location: 'CISAC', time: 'Time TBC' },
        { title: 'Dramatic, Literary and Audiovisual Repertoire Group (DLVRG)', location: 'SACD', time: '09:30-12:30' },
        { title: 'BIEM Management Committee (BIEM MC)', location: 'SACEM, Darius Milhaud Room', time: '10:00-12:00' }
      ],
      afternoon: [
        { title: "Asia-Pacific Music Creators' Alliance Executive Committee (APMA ExCo)", location: 'ADAGP Auditorium', time: '14:00-15:00' },
        { title: 'African Committee (CAF)', location: 'CISAC', time: 'Time TBC' },
        { title: 'BIEM General Assembly (BIEM GA)', location: 'SACEM Auditorium', time: '14:00-16:00' }
      ]
    },
    {
      day: 'Wednesday, June 3, 2026',
      morning: [
        { title: 'CISAC Board of Directors', location: 'SACEM', time: '09:30-13:00' },
        { title: 'Alliance of Asia-Pacific Audiovisual Writers and Directors (AAPA)', location: 'CISAC', time: 'Time TBC' }
      ],
      afternoon: [
        { title: 'CISAC Board of Directors', location: 'SACEM', time: '14:30-17:00' }
      ]
    },
    {
      day: 'Thursday, June 4, 2026',
      morning: [
        { title: 'General Assembly', location: 'Pavillon Cambon', time: '09:30-13:00', highlight: true }
      ],
      afternoon: [
        { title: 'General Assembly', location: 'Pavillon Cambon', time: '14:30-17:00', highlight: true }
      ]
    },
    {
      day: 'Friday, June 5, 2026',
      morning: [
        { title: 'International Council of Music Creators Executive Committee (CIAM ExCo)', location: 'SACEM', time: 'Time TBC' },
        { title: 'Music Repertoire Group (MRG)', location: 'Venue TBC', time: '09:30-12:30' }
      ],
      afternoon: [
        { title: 'International Council of Music Creators Executive Committee (CIAM ExCo)', location: 'SACEM', time: 'Time TBC' }
      ]
    }
  ];

  return (
    <div className="schedule-page">
      {/* Hero Header */}
      <section className="schedule-hero">
        <div className="container">
          <h1>SCHEDULE</h1>
          <p>CISAC General Assembly 2026 and Related Meetings</p>
          <p className="hero-subtitle">June 1-5, 2026 - Paris, France</p>
        </div>
      </section>

      {/* Schedule Content */}
      <section className="section schedule-content">
        <div className="container">
          <div className="schedule-intro">
            <h2>Event Programme</h2>
            <p>
              The 2026 CISAC General Assembly will be held on <strong>Thursday, June 4</strong> at
              <strong> Pavillon Cambon Capucines</strong>. Various committee meetings and working groups
              will meet throughout the week at different venues across Paris.
            </p>
          </div>

          {scheduleByDay.map((day, dayIndex) => (
            <div key={dayIndex} className="schedule-day-section">
              <h2 className="day-title">{day.day}</h2>

              {/* Morning Sessions */}
              {day.morning && day.morning.length > 0 && (
                <div className="time-section">
                  <h3 className="time-label">Morning</h3>
                  <div className="events-grid">
                    {day.morning.map((event, eventIndex) => (
                      <div key={eventIndex} className={`event-card ${event.highlight ? 'event-highlight' : ''}`}>
                        <h4 className="event-title">{event.title}</h4>
                        <p className="event-time">{event.time}</p>
                        <p className="event-location">{event.location}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Lunch */}
              <div className="lunch-section">
                <p className="lunch-text">Lunch break</p>
              </div>

              {/* Afternoon Sessions */}
              {day.afternoon && day.afternoon.length > 0 && (
                <div className="time-section">
                  <h3 className="time-label">Afternoon</h3>
                  <div className="events-grid">
                    {day.afternoon.map((event, eventIndex) => (
                      <div key={eventIndex} className={`event-card ${event.highlight ? 'event-highlight' : ''}`}>
                        <h4 className="event-title">{event.title}</h4>
                        <p className="event-time">{event.time}</p>
                        <p className="event-location">{event.location}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* Note */}
          <div className="schedule-note">
            <p>
              <strong>Important Notice:</strong> This schedule is subject to change.
              Some times and locations are still to be confirmed. All registered participants
              will receive final confirmation and detailed information via email before the event.
            </p>
          </div>
        </div>
      </section>

      {/* Contacts Section */}
      <section className="section contacts-section">
        <div className="container">
          <h2>CONTACT INFORMATION</h2>
          <p>For questions about registration and meetings, please contact:</p>
          <div className="contact-card">
            <p>Registration & Accommodation</p>
            <p>Email: <a href="mailto:2026ga@cisac.org">2026ga@cisac.org</a></p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SchedulePage;
